<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
      </div>
    </section>

    <!-- card profile -->
    <section class="section section-skew">
      <div class="container">
        <card shadow class="card-profile mt--300" no-body>
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <img
                    v-lazy="require('@/assets/images/perfil.jpg')"
                    class="img-fluid rounded-circle"
                  />
                </div>
              </div>
              <div
                class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center"
              >
                <div class="card-profile-actions py-4 mt-lg-0">
                  <base-button
                    type="info"
                    size="sm"
                    class="mr-4"
                    @click="$router.push('/portifolio')"
                    >Portifolio</base-button
                  >
                  <base-button
                    type="default"
                    size="sm"
                    class="float-right"
                    @click="$router.push('/contact')"
                    >Contato</base-button
                  >
                </div>
              </div>
              <div class="col-lg-4 order-lg-1">
                <div class="card-profile-stats d-flex justify-content-center">
                  <div>
                    <span class="heading">{{ networking }}</span>
                    <span class="description">Networking</span>
                  </div>
                  <div>
                    <span class="heading">{{ projects }}</span>
                    <span class="description">Projetos</span>
                  </div>
                  <div>
                    <span class="heading">{{ apis }}</span>
                    <span class="description">APIs</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-5">
              <h3>
                Leandro Cantiero Campagnolo
                <span class="font-weight-light">, {{ idade }}</span>
              </h3>
              <div class="h6 font-weight-300">
                <i class="ni location_pin mr-2"></i>Presidente Prudente, São
                Paulo
              </div>
              <div class="h6 mt-4">
                <i class="ni business_briefcase-24 mr-2"></i>Desenvolvedor e
                Analista de sistemas
              </div>
              <div>
                <i class="ni education_hat mr-2"></i>Formado na Faculdade de
                Informática de Presidente Prudente - Unoeste
              </div>
            </div>
            <div class="mt-5 py-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <p>
                    Desenvolvendo aplicativos desde 2018, comecei com sistemas
                    em Delphi (um dinossauro do mercado rs), logo depois já
                    iniciei no desenvolvimento web focando em sites
                    institucionais e sistemas de gestão financeira.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section>

    <!-- habilidades & formação -->
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">
              <span class="text-success">Algumas das minhas habilidades</span>
            </h2>
            <!-- <p class="lead">
              Cause if you do, it can be yours for FREE. Hit the button below to
              navigate to Creative Tim where you can find the Design System in
              HTML. Start a new project or give an old Bootstrap project a new
              look!
            </p> -->
            <div class="text-center">
              <div class="row justify-content-center align-items-center">
                <div class="col-lg-2 col-4">
                  <a
                    href="https://vuejs.org/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="Vue.js - The progressive javascript framework"
                  >
                    <img
                      v-lazy="require('@/assets/images/vue.jpg')"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://vuetifyjs.com/en/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="Vuetify.js - The UI VueJS framework"
                  >
                    <img
                      v-lazy="require('@/assets/images/vuetify.png')"
                      width="75%"
                      class="img-fluid mt-2"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://getbootstrap.com/"
                    target="_blank"
                    data-toggle="tooltip"
                    data-original-title="Bootstrap 4 - Most popular front-end component library"
                  >
                    <img
                      v-lazy="require('@/assets/images/bootstrap.jpg')"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://nodejs.org/"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/nodejs.png')"
                      width="100%"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://dotnet.microsoft.com/apps/aspnet"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/netcore.png')"
                      width="60%"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://www.postgresql.org/"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/postgreSQL.png')"
                      width="60%"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <!-- <div class="col-lg-2 col-4">
                  <a
                    href="https://www.mongodb.com/"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/mongodb.png')"
                      width="60%"
                      class="img-fluid"
                    />
                  </a>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container mt-5">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">
              <span class="text-success">Formação</span>
            </h2>
            <span> bacharel em Sistemas de Informação pela FIPP - Unoeste</span>
            <div class="text-center">
              <div class="row justify-content-center align-items-center mt-5">
                <div class="col-lg-2 col-4">
                  <a
                    href="https://www.unoeste.br/fipp/"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/fipp.png')"
                      class="img-fluid"
                    />
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://www.unoeste.br"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <img
                      v-lazy="require('@/assets/images/unoeste.jpg')"
                      class="img-fluid"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- timeline -->
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid justify-content-center mr-5">
          <div class="col-lg-11 text-center mr-5">
            <vue-timeline-update
              v-for="item in timeLineData"
              :key="item.description"
              :date="item.date"
              :title="item.title"
              :description="item.description"
              :thumbnail="item.thumbnail"
              :category="item.category"
              :color="item.color"
            ></vue-timeline-update>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  computed: {
    idade() {
      return new Date().getFullYear().toString().substr(2, 4);
    },
    networking() {
      return 36;
    },
    projects() {
      return 17;
    },
    apis() {
      return 6;
    },
  },
  data: () => ({
    timeLineData: [
      {
        date: new Date("2020-01-24"),
        title: "Férias em família",
        description: "Nessas férias fomos para a praia de Guaratuba-PR",
        category: "Lazer",
        color: "blue",
        thumbnail: require("@/assets/images/praia1.jpg"),
      },
      {
        date: new Date("2020-01-23"),
        title: "Visita ao zoológico de Curitiba-PR",
        description:
          "Nessas férias também fizemos uma visita ao zoológico municipal de Curitiba-PR",
        category: "Lazer",
        color: "blue",
        thumbnail: require("@/assets/images/zoo1.jpg"),
      },
      {
        date: new Date("2019-03-29"),
        title: "Manutenção semestral na máquina",
        description:
          "Sempre fiz a manutenção dos meus notebooks e pcs eu mesmo",
        category: "Hardware",
        color: "green",
        thumbnail: require("@/assets/images/hardware.jpg"),
      },
      {
        date: new Date("2018-06-12"),
        title: "Um pouco de barulho",
        description:
          "Toco na igreja desde os 13 anos e ainda vou ter minha própria bateria hehe",
        category: "Instrumento",
        color: "red",
        thumbnail: require("@/assets/images/bateria.jpg"),
      },
      {
        date: new Date("2018-06-12"),
        title: "Exercício como um hobby",
        description:
          "Exercitar o corpo é tão importante quanto exercitar a mente. Quanto sua gatinha deixar é claro ...",
        category: "Exercícios",
        color: "yellow",
        thumbnail: require("@/assets/images/exercicios.jpg"),
      },
    ],
  }),
};
</script>

<style>
[class^="gb-"]:not(.gb-base-icon) {
  font-family: Arial, Helvetica, sans-serif !important;
}
</style>


